var audio_rtlignore_default = {
  "fontElementMap": "qpDUo",
  "container": "-demy",
  "customPlayer": "OQJCZ",
  "slim": "_9t6sE",
  "playPauseButton": "caag6",
  "coverImage": "Vv30s",
  "trackDetailsContainer": "xn9ix",
  "controlsContainer": "DkbsX",
  "controlsGroup": "b4VvO",
  "sliderContainer": "xiweQ",
  "audioDuration": "spiLQ",
  "isLoading": "-If3z",
  "audioDetails": "f4eA6",
  "authorName": "_9AbCU",
  "title": "UJ-FH",
  "dropdownMenuWrapper": "NmQwf",
  "dropdownSelectedButton": "FjWn4",
  "dropdownContent": "nvKnp",
  "dropdownContentWithIcon": "Qa3ws",
  "audioLoader": "_3K5GB"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
